import Request from "../Request";

const authentication = {
  validateBobbieToken(data) {
    return Request.post("/airbob/validate-token/", data);
  },
};

export default authentication;
